import { PrimaryButtonLink } from '@/components/common/PrimaryButton';
import { IoMdCheckboxOutline } from 'react-icons/io';
import { ImagesWhySpiritoryWhySpiritoryV2Webp } from '@/assets/images_why-spiritory.assets';
import Image from 'next/image';
import { IndexWhyBuyOnSpiritoryProps } from '@/types';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { CommonEnum } from '@/types/translations/CommonEnum';

export default function IndexWhyBuyOnSpiritory({ user }: IndexWhyBuyOnSpiritoryProps) {
  const { translate: translateCommon } = useTypedTranslation<CommonEnum>('common');
  const isSeller = Boolean(user?.canAsk);
  return (
    <div className="tw-relative tw-flex tw-h-fit tw-items-stretch tw-rounded-[20px] max-nine:tw-px-4 nine:tw-max-h-[640px]">
      <div className="tw-w-2/4 tw-rounded-bl-[20px] tw-rounded-tl-[20px] tw-bg-main tw-px-12 tw-py-11 max-nine:tw-w-full max-nine:tw-rounded-[20px] max-nine:tw-p-4">
        <div className="tw-mb-10 tw-w-full nine:tw-hidden">
          <Image
            src={ImagesWhySpiritoryWhySpiritoryV2Webp}
            alt="Why buy on Spiritory?"
            width={344}
            height={244}
            className="tw-w-full tw-rounded-lg tw-object-cover"
          />
        </div>
        <h2 className="tw-w-fit tw-font-prata tw-text-4xl tw-font-thin tw-text-white max-nine:tw-text-xl">
          {translateCommon(CommonEnum['why_buy_on_spiritory'])}
          <hr
            aria-hidden="true"
            className="tw-mt-4 tw-h-[5px] tw-w-[80%] tw-rounded-full tw-border-none tw-bg-custom-gold tw-opacity-100"
          />
        </h2>
        <ul className="tw-my-10 tw-flex tw-flex-col tw-gap-6 tw-p-0">
          <li className="tw-flex tw-items-center tw-gap-4">
            <IoMdCheckboxOutline className="tw-max-h-[25px] tw-min-h-[25px] tw-min-w-[25px] tw-max-w-[25px] tw-text-white" />
            <p
              className="tw-m-0 tw-p-0 tw-text-base tw-text-white"
              dangerouslySetInnerHTML={{
                __html: translateCommon(
                  CommonEnum['secure_payments_through_our_trusted_escrow_system']
                ),
              }}
            />
          </li>
          <li className="tw-flex tw-items-center tw-gap-4">
            <IoMdCheckboxOutline className="tw-max-h-[25px] tw-min-h-[25px] tw-min-w-[25px] tw-max-w-[25px] tw-text-white" />
            <p
              className="tw-m-0 tw-p-0 tw-text-base tw-text-white"
              dangerouslySetInnerHTML={{
                __html: translateCommon(
                  CommonEnum['expert_verified_bottles_for_guaranteed_authenticity']
                ),
              }}
            />
          </li>
          <li className="tw-flex tw-items-center tw-gap-4">
            <IoMdCheckboxOutline className="tw-max-h-[25px] tw-min-h-[25px] tw-min-w-[25px] tw-max-w-[25px] tw-text-white" />
            <p
              className="tw-m-0 tw-p-0 tw-text-base tw-text-white"
              dangerouslySetInnerHTML={{
                __html: translateCommon(
                  CommonEnum['only_verified_sellers_meet_our_strict_quality_standards']
                ),
              }}
            />
          </li>
          <li className="tw-flex tw-items-center tw-gap-4">
            <IoMdCheckboxOutline className="tw-max-h-[25px] tw-min-h-[25px] tw-min-w-[25px] tw-max-w-[25px] tw-text-white" />
            <p
              className="tw-m-0 tw-p-0 tw-text-base tw-text-white"
              dangerouslySetInnerHTML={{
                __html: translateCommon(CommonEnum['expert_support_whenever_you_need_assistance']),
              }}
            />
          </li>
          <li className="tw-flex tw-items-center tw-gap-4">
            <IoMdCheckboxOutline className="tw-max-h-[25px] tw-min-h-[25px] tw-min-w-[25px] tw-max-w-[25px] tw-text-white" />
            <p
              className="tw-m-0 tw-p-0 tw-text-base tw-text-white"
              dangerouslySetInnerHTML={{
                __html: translateCommon(CommonEnum['insured_shipping_to_protect_your_investment']),
              }}
            />
          </li>
        </ul>
        <PrimaryButtonLink
          white={true}
          href={isSeller ? '/search' : '/auth/onboarding'}
          className="tw-px-20 tw-py-3 max-nine:tw-w-full max-nine:tw-text-lg"
        >
          {translateCommon(CommonEnum['start_selling'])}
        </PrimaryButtonLink>
      </div>
      <div className="tw-absolute tw-right-0 tw-h-full tw-w-2/4 max-nine:tw-hidden">
        <Image
          src={ImagesWhySpiritoryWhySpiritoryV2Webp}
          alt="Why buy on Spiritory?"
          width={500}
          height={500}
          className="tw-h-full tw-w-full tw-rounded-br-[20px] tw-rounded-tr-[20px] tw-object-cover tw-object-center"
        />
      </div>
    </div>
  );
}
